import { EnvironmentStages } from '@/models/environment'

export const getBaseUrls = ({
  pathPrefix = ''
}: {
  pathPrefix?: string
}) => {
  const baseUrls: Record<EnvironmentStages, string> = {
    [EnvironmentStages.local]: 'http://localhost:3011/graphql',

    [EnvironmentStages.dev]: `https://api.dev.ppwr.io/${pathPrefix}graphql`,
    [EnvironmentStages.test]: 'https://5bjatv9fw4.execute-api.us-east-1.amazonaws.com/test',
    [EnvironmentStages.prod]: `https://api.prod.ppwr.io/${pathPrefix}graphql`
  }

  const baseWebSocketUrls: Record<EnvironmentStages, string> = {
    [EnvironmentStages.local]: 'ws://localhost:3011/graphql',
    [EnvironmentStages.dev]: `wss://ws.dev.ppwr.io/${pathPrefix}`,
    [EnvironmentStages.test]: 'wss://5bjatv9fw4.execute-api.us-east-1.amazonaws.com/test',
    [EnvironmentStages.prod]: `wss://ws.prod.ppwr.io/${pathPrefix}`
  }

  return { baseUrls, baseWebSocketUrls }
}
